import { render, staticRenderFns } from "./MyPasswordChangeUpdate.vue?vue&type=template&id=72b84b72&scoped=true&"
import script from "./MyPasswordChangeUpdate.vue?vue&type=script&lang=js&"
export * from "./MyPasswordChangeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MyPasswordChangeUpdate.vue?vue&type=style&index=0&id=72b84b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b84b72",
  null
  
)

export default component.exports